module.exports = __webpack_public_path__ + "img/avatar.0c675689.svg";